module.exports = __webpack_public_path__ + "img/1.0e2ff868.png";